import _ from 'lodash';
import update from 'immutability-helper';
import objectAssign from 'object-assign';
import * as types from '../constants/actionTypes';
// import $ from 'jquery';
import 'whatwg-fetch';
import * as utils from './actionUtils';
import toastr from 'toastr';
import { push } from 'react-router-redux';
// import dateHelper from '../utils/dateHelper';

let defaultDelay = 0;
if (process.env.NODE_ENV === 'development') {
  defaultDelay = 200;
}

export function loadClubMembers(clubId) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    let url = 'clubs/' + clubId + '/members';
    utils.getData(url,
      (result) => {dispatch(loadClubMembersSuccess(result));},
      (error) => {dispatch(loadClubsMembersFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_CLUB_MEMBERS,
    });
  };
}

export function loadClubMembersSuccess(memberList) {
  return {
    type: types.LOAD_CLUB_MEMBERS_SUCCESS,
    memberList: memberList,
    memberListUpdated: Date.now(),
  };
}

export function loadMemberDetails(clubId, id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.getData('clubs/'+ clubId +'/members/' + id,
      (result) => {dispatch(loadMemberDetailsSuccess(result));},
      (error) => {dispatch(loadClubsMembersFail(error));},
      defaultDelay);
    return dispatch({
      type: types.LOAD_MEMBER_DETAILS,
    });
  };
}

export function loadMemberDetailsSuccess(memberDetails) {
  return {
    type: types.LOAD_MEMBER_DETAILS_SUCCESS,
    memberDetails: memberDetails,
    memberDetailsUpdated: Date.now(),
  };
}


export function loadClubsMembersFail(error) {
  return function(dispatch) {
    dispatch({
      type: types.LOAD_CLUB_MEMBERS_FAILURE,
      errors: error,
    });
  };
}

export function updateMember(memberDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/'+ memberDetails.club +'/members/' + memberDetails.id, 'PUT', memberDetails,
      (result) => {dispatch(updateMemberSuccess(result));},
      (errors) => {dispatch(updateMemberFail(errors));},
      defaultDelay);
  };
}

export function createMember(memberDetails) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/' + memberDetails.club +'/members', 'POST', memberDetails,
      (result) => {dispatch(createMemberSuccess(result));},
      (errors) => {dispatch(updateMemberFail(errors));},
      defaultDelay);
  };
}

export function updateMemberSuccess(memberDetails) {
  return function(dispatch, getState) {
    toastr.success('Lagret');
    let memberList = objectAssign([], getState().clubs.memberList);
    if (memberList.length > 0) {
      let index = _.indexOf(memberList, _.find(memberList, {id: memberDetails.id}));
      memberList.splice(index, 1, memberDetails);
    }
    dispatch({
      type: types.UPDATE_MEMBER_DETAILS_SUCCESS,
      memberDetails: memberDetails,
      memberList: memberList,
      memberDetailsUpdated: Date.now(),
      memberListUpdated: Date.now(),
    });
  };
}

export function createMemberSuccess(memberDetails) {
  return function(dispatch, getState) {
    let memberList = objectAssign([], getState().clubs.memberList);
    if (memberList.length > 0) {
      memberList.push(memberDetails);
    }
    toastr.success('Opprettet');
    dispatch(push('/klubb/' + memberDetails.club + '/medlem/' + memberDetails.id + '/rediger'));
    dispatch({
      type: types.CREATE_MEMBER_DETAILS_SUCCESS,
      memberDetails: memberDetails,
      memberList: memberList,
      memberDetailsUpdated: Date.now(),
      memberListUpdated: Date.now(),
    });
  };
}

export function updateMemberFail(errors) {
  return function(dispatch) {
    toastr.warning('Lagring feilet');
    dispatch({
      type: types.LOAD_CLUB_MEMBERS_FAILURE,
      errors: errors,
    });
  };
}

export function deleteMember(member) {
  return function (dispatch, getState) {
    let memberList = getState().clubs.memberList;
    dispatch(utils.beginAjaxCall());
    utils.deleteData('clubs/'+ member.club +'/members/' + member.id, () => {
      let memberIndex = _.findIndex(memberList, {id: member.id});
      memberList = update(memberList, {[memberIndex]: {
        archived: {$set: true}
      }});
      dispatch(loadClubMembersSuccess(memberList));
      dispatch(push('/klubb/' + member.club));
      toastr.success('Slettet');
    }, defaultDelay);
  };
}

export function restoreMember(clubId, id) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/'+ clubId +'/members/' + id, 'POST', {},
      (result) => {dispatch(updateMemberSuccess(result));},
      (errors) => {dispatch(updateMemberFail(errors));},
      defaultDelay);
  };
}

export function importMembers(clubId, importArray) {
  return function (dispatch) {
    dispatch(utils.beginAjaxCall());
    utils.sendData('clubs/' + clubId + '/members/import', 'POST',
      importArray,
      (result) => {
        toastr.success('Import vellykket');
        dispatch(loadClubMembers(clubId));
        dispatch(push('/klubb/' + clubId));
      },
      (errors) => {
        toastr.error(errors, 'Import feilet.');
      },
      defaultDelay);
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/memberActions.js
 **/